export const CHARACTERISTICS_MAP = {
  ADVERTENCE: { name: 'Advertência', id: 10 },
  ANTIBIOTICO: { name: 'Antibiótico', id: 14 },
  PSICOTROPICO: { name: 'Psicotrópico', id: 17 },
  PROMOTIONAL_PACK: { name: 'Promocional', id: 29 },
  DESCONTINUADO: { name: 'Descontinuado', id: 30 },
  PBM_PROGRAM: { name: 'Programa PBM', id: 31 },
  ORDER_LIMIT: { name: 'Limite por Pedido', id: 32 },
  RECIPE_VALIDITY_DAYS: { name: 'Validade da receita (Dias)', id: 33 },
  REFERENCE: { name: 'Referência', id: 34 },
  HAS_GENERIC: { name: 'Tem Genérico', id: 35 },
  BULA: { name: 'Bula', id: 36 },
  LAB_DISCOUNT_INFO_NOTE: {
    name: 'Texto informativo desconto laboratório',
    id: 38,
  },
  MAX_CARD_INSTALLMENTS: {
    name: 'Máximo de parcelas no cartão',
    id: 42,
  },
};
